<template>
	<div class="Loading-wrapper">
		<div
			:class="['Loading', { dark: dark }, { large: large }]"
			v-if="!dots"
		></div>
		<div :class="['saving', { dark: dark }]" v-if="saving">
			<span>Saving</span>
		</div>
		<div :class="['loader', { dark: dark }, { large: large }]" v-if="dots">
			<span class="loader__dot">.</span>
			<span class="loader__dot">.</span>
			<span class="loader__dot">.</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Loading',
	props: {
		dark: {
			type: Boolean,
			default: false
		},
		large: {
			type: Boolean,
			default: false
		},
		saving: {
			type: Boolean,
			default: false
		},
		dots: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
.Loading-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	.Loading {
		box-sizing: border-box;
		display: inline-block;
		width: 20px;
		height: 20px;
		border: 3px solid rgba(255, 255, 255, 0.3);
		border-radius: 50%;
		border-top-color: #fff;
		animation: spin 1s ease-in-out infinite;
		-webkit-animation: spin 1s ease-in-out infinite;

		&.dark {
			border: 3px solid $colorPrimary3;
			border-top-color: $colorPrimary8;
		}

		&.large {
			width: 50px;
			height: 50px;
		}
	}
	.saving {
		margin-top: 10px;
		color: white;

		&.dark {
			color: $colorPrimary8;
		}
	}

	.loader {
		color: white;

		&.dark {
			color: $colorPrimary8;
		}

		&.large {
			font-size: 40px;
		}
	}

	@-webkit-keyframes blink {
		50% {
			color: transparent;
		}
	}
	@keyframes blink {
		50% {
			color: transparent;
		}
	}
	.loader__dot {
		-webkit-animation: 1s blink infinite;
		animation: 1s blink infinite;
	}
	.loader__dot:nth-child(2) {
		-webkit-animation-delay: 250ms;
		animation-delay: 250ms;
	}
	.loader__dot:nth-child(3) {
		-webkit-animation-delay: 500ms;
		animation-delay: 500ms;
	}

	/* Safari 4.0 - 8.0 */
	@-webkit-keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}

	/* Standard syntax */
	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
}
</style>
